import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';
import i18n from 'i18next';
import enGB from '../../public/v2/locales/en-GB/translation.json';
import enUS from '../../public/v2/locales/en-US/translation.json';

import constantsFactory from '@/utils/constants';

const {COOKIE, LOCALE_DEFAULT} = constantsFactory();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS: 'translation',
    ns: ['translation'],
    compatibilityJSON: 'v4',
    fallbackLng: LOCALE_DEFAULT,
    debug: process.env.NODE_ENV !== 'production',
    detection: {
      order: ['queryString', 'cookie'],
      lookupCookie: COOKIE.LOCALE,
    },
    supportedLngs: ['en-GB', 'en-US'],
    load: 'currentOnly',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    resources: {
      'en-GB': {translation: enGB},
      'en-US': {translation: enUS},
    },
  });

export default i18n;
